export default "__VITE_ASSET__DMFScbF___"